import { render, staticRenderFns } from "./HistoryPropertyList.vue?vue&type=template&id=6a3aa7f8&"
import script from "./HistoryPropertyList.vue?vue&type=script&lang=js&"
export * from "./HistoryPropertyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports